module.exports = __webpack_public_path__ + "static/media/amex.babeb31e.png";